import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handlePopState = this.handlePopState.bind(this)
    this.handleFrameRender = this.handleFrameRender.bind(this)
    window.addEventListener("popstate", this.handlePopState)
    document.addEventListener("turbo:frame-render", this.handleFrameRender)
    this.syncToLocation()
  }

  disconnect() {
    window.removeEventListener("popstate", this.handlePopState)
    document.removeEventListener("turbo:frame-render", this.handleFrameRender)
  }

  submit(event) {
    const form = event.currentTarget.form
    if (!form) return

    this.removePage(form)
    this.prepareSubmission(form, "advance", "filter")
    form.requestSubmit()
  }

  clear(event) {
    event.preventDefault()

    const form = this.formFor(event.currentTarget)
    if (!form) return

    form.querySelectorAll("input:not([type='hidden']), select").forEach((field) => {
      if (field.tagName === "SELECT") {
        field.selectedIndex = 0
      } else {
        field.value = ""
      }
    })

    this.removePage(form)
    this.prepareSubmission(form, "advance", "filter")
    this.submitWithoutFilterParams(form)
  }

  paginate(event) {
    event.preventDefault()

    const form = this.formFor(event.currentTarget)
    if (!form) return

    const page = new URL(event.currentTarget.href, window.location.href).searchParams.get("page")
    if (!page) return

    let pageField = form.querySelector("input[name='page']")
    if (!pageField) {
      pageField = document.createElement("input")
      pageField.type = "hidden"
      pageField.name = "page"
      form.appendChild(pageField)
    }
    pageField.value = page

    this.prepareSubmission(form, "advance", "pagination")
    form.requestSubmit()
  }

  formFor(element) {
    const frameId = element.dataset.turboFrame
    const forms = this.element.querySelectorAll("form[data-turbo-frame]")

    return Array.from(forms).find((form) => !frameId || form.dataset.turboFrame === frameId)
  }

  prepareSubmission(form, action, submissionType = "filter") {
    form.dataset.browseFilterAction = action
    form.dataset.browseFilterSubmission = submissionType
  }

  removePage(form) {
    form.querySelector("input[name='page']")?.remove()
  }

  submitWithoutFilterParams(form) {
    const fields = Array.from(form.elements).filter((field) => field.name && field.type !== "hidden")
    const enabledFields = fields.filter((field) => !field.disabled)

    enabledFields.forEach((field) => { field.disabled = true })
    form.requestSubmit()
    enabledFields.forEach((field) => { field.disabled = false })
  }

  handlePopState() {
    const params = new URL(window.location.href).searchParams
    this.syncToLocation(params)
  }

  handleFrameRender(event) {
    const frameId = event.target?.id
    if (!frameId) return

    const ownsFrame = Array.from(this.element.querySelectorAll("form[data-turbo-frame]"))
      .some((form) => form.dataset.turboFrame === frameId)
    if (ownsFrame) this.syncClearControl()
  }

  syncToLocation(params = new URL(window.location.href).searchParams) {
    this.element.querySelectorAll("form[data-turbo-frame]").forEach((form) => {
      form.querySelectorAll("input[name], select[name]").forEach((field) => {
        if (field.type === "hidden") {
          if (field.name === "page") {
            if (params.has("page")) {
              field.value = params.get("page")
            } else {
              field.remove()
            }
          }
          return
        }

        if (field.tagName === "SELECT") {
          field.value = params.has(field.name) ? params.get(field.name) : field.options[0]?.value || ""
        } else {
          field.value = params.get(field.name) || ""
        }
      })
    })

    this.syncClearControl(params)
  }

  syncClearControl(params = new URL(window.location.href).searchParams) {
    const container = this.element.querySelector("[data-browse-filter-clear-container]")
    if (!container) return

    const shouldShow = params.get("scope") === "following" &&
      Boolean(params.get("cook_id") || params.get("dish_id"))
    const selector = "[data-browse-filter-following-clear-link]"
    const existingLink = container.querySelector(selector)

    if (!shouldShow) {
      existingLink?.remove()
      return
    }
    if (existingLink) return

    const link = document.createElement("a")
    link.href = container.dataset.browseFilterClearPath
    link.textContent = "Clear filters"
    link.className = "ec-btn ec-btn-secondary"
    link.dataset.turbo = "false"
    link.dataset.turboFrame = "preparations_results"
    link.dataset.action = "click->browse-filter-form#clear"
    link.dataset.browseFilterFollowingClearLink = "true"
    container.append(link)
  }
}
